/**
 * Service pour la homepage avec sections de mise en bouche
 * 
 * Ce fichier contient les interfaces et utilitaires pour la gestion
 * des sections de contenu sur la homepage
 */

export interface Content {
  id: string | number
  title: string
  description?: string
  status: string
  createdAt: string
  thumbnailS3Key?: string
  duration?: number
  category?: string
  isPremium?: boolean
  views?: number // Nombre de vues
  // Métadonnées spécifiques au provider pour accéder à la vidéo
  provider?: 'eporner' | 'letsjerktv' | 'redtube' | 'pornhub' | 'local'
  providerVideoId?: string // ID original du provider (sans préfixe)
  providerVideoUrl?: string // URL pour LetsJerktv
}

export interface Section {
  id: string
  title: string
  description: string
  maxFreeVideos: number
  videos: Content[]
}

/**
 * Structure attendue de l'API
 * GET /contents/sections
 * 
 * Retourne un tableau de sections avec leurs vidéos
 */
export interface SectionsApiResponse {
  sections: Section[]
  // Autres métadonnées si nécessaire
}

/**
 * Utilitaires pour la gestion des accès aux vidéos
 */
export class AccessManager {
  /**
   * Détermine si une vidéo est accessible gratuitement
   */
  static isFreeVideo(videoIndex: number, maxFreeVideos: number): boolean {
    return videoIndex < maxFreeVideos
  }

  /**
   * Détermine si l'utilisateur a accès à une vidéo
   */
  static hasAccessToVideo(
    videoIndex: number, 
    maxFreeVideos: number, 
    hasActiveSubscription: boolean
  ): boolean {
    return this.isFreeVideo(videoIndex, maxFreeVideos) || hasActiveSubscription
  }

  /**
   * Formate la durée d'une vidéo
   */
  static formatDuration(duration?: number): string {
    if (!duration) return ''
    return `${Math.floor(duration / 60)}:${(duration % 60).toString().padStart(2, '0')}`
  }
}

/**
 * Configuration par défaut des sections
 * Adapté pour utiliser les providers AdultContentController
 */
export const DEFAULT_SECTIONS: Partial<Section>[] = [
  {
    id: 'eporner',
    title: 'Les nouveautés',
    description: 'Découvrez les dernières sorties et les contenus les plus récents',
    maxFreeVideos: 3,
    videos: []
  },
  {
    id: 'letsjerktv',
    title: 'Les incontournables', 
    description: 'Une sélection des contenus les plus populaires et appréciés',
    maxFreeVideos: 3, // 3 vidéos gratuites, 5 premium/vip
    videos: []
  },
  {
    id: 'redtube',
    title: 'Notre sélection',
    description: 'Des vidéos soigneusement choisies pour leur qualité et leur originalité',
    maxFreeVideos: 2,
    videos: []
  }
]
